import { GableToolCard } from '../../../services/gable/gable.service';

/**
 * Whether a chat message hosts an action proposal, in any state.
 *
 * Such a message never shows follow-up chips: pending, they distract from the confirm;
 * committed, they offer the change that just happened and drafts there is no undo for.
 */
export function messageCarriesProposal(toolCards: GableToolCard[] | undefined): boolean {
    return (toolCards ?? []).some((card) => card.tool === 'propose_action' || card.tool === 'propose_crud_change');
}
